/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Voice_Demo_DescriptionInputs */

const en_features_voice_demo_description = /** @type {(inputs: Features_Voice_Demo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll be amazed at just how realistic these voices sound. Choose from our library of 20+ voices. Give it a try for yourself!`)
};

const es_features_voice_demo_description = /** @type {(inputs: Features_Voice_Demo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te sorprenderá lo realistas que suenan estas voces. Elige de nuestra biblioteca de más de 20 voces. ¡Pruébalo tú mismo!`)
};

/**
* | output |
* | --- |
* | "You'll be amazed at just how realistic these voices sound. Choose from our library of 20+ voices. Give it a try for yourself!" |
*
* @param {Features_Voice_Demo_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_voice_demo_description = /** @type {((inputs?: Features_Voice_Demo_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Voice_Demo_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_voice_demo_description(inputs)
	return en_features_voice_demo_description(inputs)
});